import React from 'react';

const MenuHero = () => {
  return (
    <div
      className="container py-10"
      style={{
        backgroundColor: '#000', // Black theme
        color: '#fff', // White text for contrast
        fontFamily: "'Poppins', sans-serif", // Font matching upper section
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginTop: '40px',
          marginBottom: '40px',
          fontWeight: '700',
          fontSize: '2.5rem',
          color: '#fff',
        }}
      >
        Our Menu
      </h1>
      <p
        style={{
          textAlign: 'center',
          maxWidth: '600px',
          margin: '0 auto 40px',
          fontSize: '1.2rem',
          color: '#ccc', // Light gray for readability
        }}
      >
        Explore a variety of dishes crafted to perfection for every occasion.
      </p>
  </div>
          
  );
};

export default MenuHero;
